export default class BasePopIn {
  init() {
    this.popInClass = 'base-pop-in';
    this.popInTitleClass = 'base-pop-in-title';
    this.popInTagsClass = 'base-pop-in-tags';
    this.popInDownloadButtons = Array.from(
      document.querySelectorAll('[data-pop-in-type]')
    );

    if (this.popInDownloadButtons.length) {
      this.popInDownloadButtons.forEach((popInDownloadButton) => {
        let popInType = popInDownloadButton.getAttribute('data-pop-in-type');
        let popInHTML = document.querySelector(
          `[data-pop-in="${popInType}"] > .${this.popInClass}`
        );

        if (popInHTML) {
          let popInHTMLTitle = popInHTML.querySelector(
            `.${this.popInTitleClass}`
          );
          let popInHTMLTags = popInHTML.querySelector(
            `.${this.popInTagsClass}`
          );

          popInDownloadButton.addEventListener('click', () => {
            let popInTitle =
              popInDownloadButton.getAttribute('data-pop-in-title') ?? '';
            let popInTags =
              popInDownloadButton.getAttribute('data-pop-in-tags') ?? '';

            let fileAttachments = {
              url:
                popInDownloadButton.getAttribute('data-file-attachments') ?? '',
              name:
                popInDownloadButton.getAttribute(
                  'data-file-attachments-name'
                ) ?? '',
              type:
                popInDownloadButton.getAttribute(
                  'data-file-attachments-type'
                ) ?? '',
              postId:
                popInDownloadButton.getAttribute(
                  'data-file-attachments-post-id'
                ) ?? '',
            };

            const postUrl = popInDownloadButton.getAttribute('data-post-url');

            if (
              (!fileAttachments.url || fileAttachments.url === '') &&
              postUrl &&
              postUrl !== ''
            ) {
              window.location.href = postUrl;

              return;
            }

            this.handleFormAttachment(popInHTML, fileAttachments);

            if (popInHTMLTitle) {
              popInHTMLTitle.innerHTML = popInTitle;
            }

            if (popInHTMLTags) {
              popInHTMLTags.innerHTML = popInTags;
            }

            popInHTML.classList.add('is-open');
          });
        }
      });
    }

    this.popInCloseButtons = Array.from(
      document.querySelectorAll(
        `.${this.popInClass}__content-close-button, .${this.popInClass}__backdrop-close-button`
      )
    );

    for (let popInCloseButton of this.popInCloseButtons) {
      popInCloseButton.addEventListener('click', () => {
        let activePopIns = document.querySelector(
          `.${this.popInClass}.is-open`
        );

        if (activePopIns) {
          let popInHTMLTitle = activePopIns.querySelector(
            `.${this.popInTitleClass}`
          );

          activePopIns.classList.remove('is-open');

          if (popInHTMLTitle) {
            popInHTMLTitle.innerHTML = '';
          }

          if (
            this.newsPopIn &&
            activePopIns === this.newsPopIn.querySelector(`.${this.popInClass}`)
          ) {
            let newsPopInCookie = this.newsPopIn.getAttribute(
              'data-pop-in-timestamp-cookie'
            );

            this.setCookie(newsPopInCookie, 'shown', 14);
          }
        }
      });
    }

    this.newsPopIn = document.querySelector('[data-pop-in="news"]');

    if (this.newsPopIn) {
      let newsPopInCookie = this.newsPopIn.getAttribute(
        'data-pop-in-timestamp-cookie'
      );
      let newsPopInHTML = this.newsPopIn.querySelector(`.${this.popInClass}`);

      if (!this.getCookie(newsPopInCookie)) {
        setTimeout(() => {
          newsPopInHTML.classList.add('is-open');
        }, 6000);
      }
    }
  }

  handleFormAttachment(container, { url, name, type, postId }) {
    if (container) {
      let customAttachmentFiles = container.querySelector(
        'input[name="custom-attachment-files"]'
      );
      let customAttachmentFilesName = container.querySelector(
        'input[name="custom-attachment-files-name"]'
      );
      let customAttachmentFilesType = container.querySelector(
        'input[name="custom-attachment-files-type"]'
      );
      let customAttachmentFilesPostId = container.querySelector(
        'input[name="custom-attachment-files-post-id"]'
      );

      if (customAttachmentFiles && url) {
        customAttachmentFiles.value = url;
      }

      if (customAttachmentFilesName && name) {
        customAttachmentFilesName.value = name;
      }

      if (customAttachmentFilesType && type) {
        customAttachmentFilesType.value = type;
      }

      if (customAttachmentFilesPostId && postId) {
        customAttachmentFilesPostId.value = postId;
      }
    }
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) return parts.pop().split(';').shift();

    return null;
  }

  setCookie(name, value, days) {
    const date = new Date();

    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/; Secure; SameSite=Lax`;
  }
}
